import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";

const ScrollToTopOnRouteChange = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  useEffect(() => {
    const raf = requestAnimationFrame(() => AOS.refresh());
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  useEffect(() => {
    if (!hash) return;

    const id = hash.slice(1);
    let cancelled = false;
    let attempts = 0;
    const maxAttempts = 30;

    const tryScroll = () => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (el) {
        // The site header is permanently position:fixed, so scrollIntoView's
        // default alignment lands headings underneath it. Offset by the
        // header's live rendered height instead of a hardcoded pixel value.
        const header = document.querySelector(".main-header");
        const headerOffset = header ? header.getBoundingClientRect().bottom : 0;
        const targetTop = el.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: targetTop - headerOffset - 20, behavior: "smooth" });
        return;
      }
      if (++attempts < maxAttempts) requestAnimationFrame(tryScroll);
    };

    const raf = requestAnimationFrame(tryScroll);
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTopOnRouteChange;
